exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17fI6{position:absolute;top:0;right:0;display:inline-block;padding:10px;color:#9d9fa2;font-size:26px;line-height:24px;z-index:1300}._3Iu5M{font-size:34px;font-weight:800;line-height:1.2}._2sEv_,._3Iu5M{text-align:center}._2sEv_{padding:15px 0 50px;color:#6d6e71;font-size:24px}", ""]);

// exports
exports.locals = {
	"close": "_17fI6",
	"title": "_3Iu5M",
	"body": "_2sEv_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./node_modules/sass-loader/lib/loader.js??ref--2-rules-4!./src/components/ModalAlert/ModalAlert.css
// module id = 1215
// module chunks = 0 1 2 3 4 5 6 7